module.exports = __webpack_public_path__ + "img/edit-cover-image-ic.5418d249.svg";